import './styles.scss';
import Button from '@/components/common/Button';
import { AlertCircle, Trash2, Info } from 'lucide-react';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Are you sure?', 
  message = 'This action cannot be undone.', 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  type = 'danger',
  isLoading = false
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger': return <Trash2 size={28} />;
      case 'warning': return <AlertCircle size={28} />;
      default: return <Info size={28} />;
    }
  };

  return (
    <div className="confirmation-modal-overlay" onClick={onClose}>
      <div className="confirmation-modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-body">
          <div className={`icon-wrapper type-${type}`}>
            {getIcon()}
          </div>
          <h3>{title}</h3>
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <Button 
            variant="ghost" 
            onClick={onClose} 
            disabled={isLoading}
          >
            {cancelText}
          </Button>
          <Button 
            variant={type === 'danger' ? 'danger' : 'primary'} 
            onClick={onConfirm}
            loading={isLoading}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
